import {
    AssessmentType,
    ExternalAssessmentStates
} from '../constants-types/Enums';
import { Assessment } from './Assessment.model';
import { Pattern } from './Pattern.model';
import { ResultBasics } from './ResultBasics.model';

export class JobAssessment implements Assessment, ResultBasics {
    jobId: string;
    assessmentState?: ExternalAssessmentStates;
    completedDate: Date;
    expirationDate?: Date;
    id: string;
    sentDate: Date;
    type?: AssessmentType = AssessmentType.Job;
    // This isn't a Person
    recipientName: string;
    recipientEmail: string;

    behavioralPattern: Pattern;

    cognitiveScore: number;
    cognitiveScaledScore: number;

    constructor(obj?: any) {
        Object.assign(this, obj);
    }

    isPending(): boolean {
        return this.assessmentState === ExternalAssessmentStates.Pending;
    }

    isExpired(): boolean {
        return this.assessmentState === ExternalAssessmentStates.Expired;
    }

    isPendingOrExpired(): boolean {
        return this.isPending() || this.isExpired();
    }

    getDisplay() {
        return this.recipientName;
    }
}
